<template>
    <div class="m-items-my">
        <div class="m-items-myFav" v-if="isLogin">
            <h3 class="c-sidebar-right-title">
                <i class="u-icon u-icon-mycollection">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M248.768 1.654L19.499 112.336a8.316 8.316 0 00-4.701 7.49v272.348a8.318 8.318 0 004.701 7.49l229.269 110.682a16.633 16.633 0 0014.464 0l229.269-110.682a8.316 8.316 0 004.701-7.49V119.826a8.318 8.318 0 00-4.701-7.49L263.232 1.654a16.64 16.64 0 00-14.464 0z" fill="#ffe17d"/><path d="M16.181 115.273a8.286 8.286 0 00-1.383 4.553v272.348a8.318 8.318 0 004.701 7.49l229.269 110.681a16.624 16.624 0 007.232 1.654V231.048L16.181 115.273z" fill="#ffc350"/><path d="M495.819 115.273a8.286 8.286 0 011.383 4.553v272.348a8.318 8.318 0 01-4.701 7.49L263.232 510.345A16.625 16.625 0 01256 512V231.048l239.819-115.775z" fill="#ffd164"/><path d="M83.407 377.657a8.298 8.298 0 01-3.606-.828L44.404 359.74a8.31 8.31 0 01-3.874-11.103c1.99-4.134 6.977-5.856 11.103-3.874l35.397 17.09a8.31 8.31 0 013.874 11.103c-1.429 2.971-4.402 4.701-7.497 4.701z" fill="#ffe17d"/><path d="M115.986 356.45a8.298 8.298 0 01-3.606-.828l-67.928-32.79c-4.134-1.998-5.872-6.969-3.874-11.103 1.99-4.126 6.985-5.856 11.103-3.874l67.927 32.79c4.134 1.998 5.872 6.969 3.874 11.103-1.428 2.971-4.401 4.702-7.496 4.702z" fill="#fff6d8"/><path fill="#ff8087" d="M414.549 154.373L173.887 38.11l-63.44 30.75 241.202 116.443z"/><path d="M351.649 185.303v90.207c0 3.066 3.205 5.078 5.967 3.745l52.232-25.215a8.316 8.316 0 004.701-7.49v-92.176l-62.9 30.929z" fill="#e6646e"/></svg>
                </i>
                <span>收藏物品</span>
            </h3>
            <div class="m-items-my-list">
                <div class="u-list" v-if="data && data.length">
                    <div class="u-item" v-for="(item, key) in data" :key="key">
                        <router-link :to="{ name: 'view', params: { item_id: item.id } }">
                            <ItemIcon :item="item" />
                        </router-link>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496.158 496.158" v-bind:class="'u-remove'" v-bind:svg-inline="''" @click.stop="remove(item.fId)" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M496.158 248.085C496.158 111.064 385.088.003 248.082.003 111.07.003 0 111.063 0 248.085c0 137.002 111.07 248.07 248.082 248.07 137.006 0 248.076-111.068 248.076-248.07z" fill="#e04f5f"/><path d="M277.042 248.082l72.528-84.196c7.91-9.182 6.876-23.041-2.31-30.951-9.172-7.904-23.032-6.876-30.947 2.306l-68.236 79.212-68.229-79.212c-7.91-9.188-21.771-10.216-30.954-2.306-9.186 7.91-10.214 21.77-2.304 30.951l72.522 84.196-72.522 84.192c-7.91 9.182-6.882 23.041 2.304 30.951a21.864 21.864 0 0014.316 5.318 21.914 21.914 0 0016.638-7.624l68.229-79.212 68.236 79.212c4.338 5.041 10.47 7.624 16.637 7.624a21.863 21.863 0 0014.311-5.318c9.186-7.91 10.22-21.77 2.31-30.951l-72.529-84.192z" fill="#fff"/></svg>
                    </div>
                </div>
                <el-pagination
                    class="u-my-items__pagination"
                    layout="prev, pager, next"
                    :page-size="pageSize"
                    :total="total"
                    background
                    small
                    hide-on-single-page
                    @current-change="pageChange"
                >
                </el-pagination>
                <!-- <a class="u-more" href="/dashboard/#/fav/item" target="_blank"
                    ><i class="el-icon-arrow-left"></i> <i class="el-icon-more"></i> <i class="el-icon-arrow-right"></i
                ></a> -->
            </div>
            <div v-if="isLogin && !data.length" class="u-tip"><i class="el-icon-warning-outline"></i> 暂无收藏物品</div>
        </div>
    </div>
</template>

<script>
import User from "@jx3box/jx3box-common/js/user";
import ItemIcon from "@/components/common/item-icon.vue";
import { getStatRank } from "@jx3box/jx3box-common/js/stat";
import { get_items, getMyFav, delMyFav } from "@/service/item.js";
import { get } from "lodash";
export default {
    name: "MyItems",
    components: {
        ItemIcon,
    },
    props: [],
    data: function () {
        return {
            isLogin: User.isLogin(),
            data: [],
            hotitems: [],
            pageSize: 24,
            total: 0,
            pageIndex: 1,
        };
    },
    computed: {
        favChangeFlag() {
            return this.$store.state.favChangeFlag;
        },
    },
    watch: {
        favChangeFlag() {
            this.loadMyItems();
        },
    },
    methods: {
        remove(fId) {
            delMyFav(fId).then((res) => {
                this.data = this.data.filter((item) => item.fId !== fId);
                this.$store.commit("SET_STATE", {
                    key: "myFavorites",
                    value: this.data,
                });
            });
        },
        loadItems: function (ids, limit) {
            return get_items({ ids: ids.join(","), limit: limit });
        },
        loadHotItems: function () {
            // 获取热门物品
            getStatRank("item").then((data) => {
                data = data.data;

                let ranks = [],
                    item_ids = [];
                for (let i in data) {
                    let name = get(data, `${i}.name`, "-");
                    let item_id = get(name.split("-"), 1, "");
                    if (item_id) {
                        item_ids.push(item_id);
                        ranks[item_id] = get(data, `${i}.value`, {});
                    }
                }

                this.loadItems(item_ids, this.pageSize).then((res) => {
                    this.hotitems = res.data.data.data;
                    // this.data = res.data.data.data;
                });
            });
        },
        pageChange(val) {
            this.pageIndex = val;
            this.loadMyItems();
        },
        loadMyItems: function () {
            // 我收藏的物品
            getMyFav({ post_type: "item", pageSize: this.pageSize, pageIndex: this.pageIndex }).then((res) => {
                let list = res.data.data.list;
                this.total = res.data.data.page.total;
                let ids = [];
                if (list) {
                    list.forEach((item) => {
                        ids.push(item.post_id);
                    });
                }

                this.loadItems(ids, this.pageSize).then((res) => {
                    this.data = res.data.data.data.map((item) => {
                        return {
                            ...item,
                            fId: list ? list.find((k) => k.post_id === item.id)?.id : null,
                        };
                    });
                });
            });
        },
    },
    mounted: function () {
        if (this.isLogin) {
            this.loadMyItems();
        }
    },
};
</script>
